import React from 'react';
import PropTypes from 'prop-types';
import Arc from 'components/common/charts/Arc';

function OverallCharts(props) {
  const { data, titleName, showAverage = true } = props;

  return (
    <article className="c-overall-charts">
      <div className="row">
        <div className="column small-12 medium-10 medium-offset-1">
          <h2 className="title">{titleName}: RGI AND COMPONENT SCORES</h2>
        </div>
      </div>
      {Object.keys(data).length ? <div className="charts row">
        <div className="composite column small-12 medium-4 medium-offset-1 print-4 print-offset-1">
          <Arc
            id="composite"
            data={data.main}
            max={100}
            height={220}
            width={220}
            radioDifference={15}
            includeTitle
            showAverage={showAverage}
          />
        </div>

        <div className="categories column small-12 medium-6 print-7">
          {data.components.map((ind, i) => (
            <div key={i} className="chart-item">
              <div className="chart">
                <Arc
                  id={`category${i}`}
                  data={ind}
                  max={100}
                  height={65}
                  width={65}
                  radioDifference={8}
                  showAverage={showAverage}
                />
                <h3 className="name">{ind.label}</h3>
              </div>
              <p className="rank">
                <span className="value">{ind.value}</span> /100
              </p>
            </div>
          ))}
        </div>
      </div> : ''}

     {showAverage && <div className="row">
       <div className="legend column small-12 medium-10 medium-offset-1">
         <p><span className="icon" /><span>Average</span></p>
       </div>
     </div>}
    </article>
  );
}

OverallCharts.propTypes = {
  data: PropTypes.object,
  titleName: PropTypes.string,
  showAverage: PropTypes.bool
};

export default OverallCharts;



// WEBPACK FOOTER //
// ./app/components/country-profiles/show/OverallCharts.jsx